<div mat-content class="mat-body-1">
    <h3 mat-dialog-title>
        {{data.title}}
    </h3>
    <mat-dialog-content class="mat-content-1">
        <p>{{data.infoText}}</p>
        <p>{{data.additionalText}}</p>
    </mat-dialog-content>
    <mat-dialog-actions class="mat-content-1 info-dialog-action">
        <button type="button"  mat-flat-button color="primary" [mat-dialog-close]="true">
            {{data.btnText}}
        </button>
    </mat-dialog-actions>
</div>
